<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="main">
    <div class="left-menu" ref="leftMenu">
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="right-container">
      <TableBox
        :title="`Transaction Group`"
        :tableData="transactionGroupList"
        :selectedRow.sync="selectedTransactionGroup"
        :loading="transactionGroupListLoading"
      />
    </div>
    <PopupEntry
      :show.sync="showPopupEntry"
      v-if="showPopupEntry"
      :title="popupEntryTitle"
      :updatedBy="updatedBy"
      :createdBy="createdBy"
      @save="popupEntrySaveClicked"
      :requiredError="popupEntryRequiredError"
      @requiredClicked="requiredClicked"
      :successMessages="popupEntrySuccessMessages"
      :messages="popupEntryMessages"
      :errorMessages="popupEntryErrorMessages"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
    >
      <!--
      TOP SECTION
      -->
      <div>
        <Input
          :placeholder="`Transaction Code`"
          :inputValue.sync="transactionCodeInputValue"
          :isRequired="true"
          :isDisabled="viewModePK"
          :errorMessage.sync="transactionCodeErr"
          ref="transactionCodeErr"
          validator="masterfilecode,25,uppercase"
        />

        <Input
          :placeholder="`Transaction Code Description`"
          :inputValue.sync="transCodeDescription"
          :isRequired="true"
          :isDisabled="viewMode"
          :errorMessage.sync="transCodeDescErr"
          ref="transCodeDescErr"
          validator="text,100"
        />
      </div>
      <!-- 
      BOTTOM SECTION
      -->
      <div class="details-section">
        <div class="transaction-group-list">
          <div v-if="!viewMode" class="button-bar">
            <button @click="addTransGroupClicked" :disabled="showChargeCode" ref="noneTransGroupErr">Add</button>
            <button @click="deleteTransGroupClicked">Delete</button>
          </div>
          <div class="table-box-container">
            <TableBox
              title="Charges Codes"
              :tableData="transGroupTableDataWithoutDeleted"
              :selectedRow.sync="selectedTransGroup"
              :maxSelection="-1"
              :hideColumns="[`_action`]"
            />
          </div>
        </div>
        <div v-if="showChargeCode" class="charge-code-list">
          <div class="button-bar">
            <button style="margin-right: 5px" :disabled="selectedChargeCode.length === 0" @click="addChargeCodeClicked">Add</button>
            <button @click="cancelChargeCodeClicked">Cancel</button>
          </div>
          <div class="table-box-container">
            <TableBox
              title="Charge Code"
              :tableData="filterChargeCodeListing"
              :selectedRow.sync="selectedChargeCode"
              :maxSelection="-1"
            />
          </div>
        </div>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    transGroupTableDataWithoutDeleted: function () {
      return this.transGroupTableData.filter((t) => t._action !== 'D');
    },

    filterChargeCodeListing: function () {
      const saved = this.transGroupTableDataWithoutDeleted
        .map((t) => t[`Charges Code`])
        .filter((code) => code && code !== '');
      return this.chargeCodeList.filter((e) => !saved.includes(e[`Charges Code`]));
    },
  },
  data: function () {
    return {
      //popup data
      popupEntryRequiredError: [],
      popupEntrySuccessMessages: [],
      popupEntryMessages: [],
      popupEntryErrorMessages: [],
      popupEntryTitle: '',
      showPopupEntry: false,
      showChargeCode: false,
      transactionGroupListLoading: false,
      createdBy: '',
      updatedBy: '',
      viewMode: false,
      viewModePK: false,

      // input data
      transactionCodeInputValue: '',
      transCodeDescription: '',

      //listing
      selectedTransactionGroup: [],
      transactionGroupList: [],
      transGroupTableData: [],
      chargeCodeList: [],
      selectedTransGroup: [],
      selectedChargeCode: [],

      //error
      transactionCodeErr: '',
      transCodeDescErr: '',

      // menu
      menu: [
        {
          title: `New Transaction Group`,
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          visible: true,
          enabled: false,
          key: 'MnuNew',
        },
        {
          title: `Edit Transaction Group`,
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          visible: true,
          key: 'MnuEdit',
        },
        {
          title: `Delete Transaction Group`,
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: false,
          visible: false,
          key: 'MnuDelete',
        },
        {
          title: `View Transaction Group`,
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
          visible: true,
          key: 'MnuView',
        },
      ],
    };
  },
  props: {},
  methods: {
    menuClicked: async function (e) {
      this.clearPopupEntryMessages();
      this.resetPopupEntryFields();
      switch (e.title) {
        case `New Transaction Group`: {
          this.popupEntryTitle = `New Transaction Group`;
          this.viewMode = false;
          this.viewModePK = false;
          this.showPopupEntry = true;
          break;
        }
        case `Edit Transaction Group`: {
          if (this.selectedTransactionGroup.length == 0) {
            this.$showAlert('error', `No transaction group is selected`, `Please select a transaction group to edit`);
            break;
          }
          this.$fullscreenLoading(`Getting transaction group Details`);
          this.populatePopupEntryFields(this.selectedTransactionGroup[0]['Transaction Code']);
          this.$fullscreenLoading('');
          this.popupEntryTitle = `Edit Transaction Group`;
          this.viewMode = false;
          this.viewModePK = true;
          this.showPopupEntry = true;
          break;
        }
        case `Delete Transaction Group`: {
          if (this.selectedTransactionGroup.length == 0) {
            this.$showAlert('error', `Delete transaction group`, `Please select a transaction group to delete`);
            return;
          }
          this.$fullscreenLoading(`Getting Transaction Group Details`);
          this.populatePopupEntryFields(this.selectedTransactionGroup[0]['Transaction Code']);
          this.$fullscreenLoading('');
          let promptMessage =
            'Are you sure you want to delete this transaction group ' +
            this.selectedTransactionGroup[0]['Transaction Code'];
          if (this.transGroupTableData.length > 0) {
            const chargeCodeCount = this.transGroupTableData.length;
            promptMessage += `<br><br>This will also delete <b>${chargeCodeCount} person${chargeCodeCount > 1 ? 's' : ''}</b>`;
          }
          const deleteConfirmation = await this.$showAlert('warning', `Delete transaction group`, promptMessage, [
            { text: 'Delete', textColor: 'white', color: 'red' },
            { text: 'Cancel' },
          ]);
          if (deleteConfirmation == 'Cancel') {
            break;
          }
          this.$fullscreenLoading(`Deleting transaction group`);
          const result = await this.$apiCallV2('/TransGroup/SaveTransGroup', this.formatSaveRequestBody('D'));
          this.$fullscreenLoading('');
          if (result[0]['Results'] != '0') {
            this.$showAlert(
              'error',
              `Transaction Code NOT Deleted`,
              `There was an error deleting Transaction Group :${this.selectedTransactionGroup[0]['Transaction Code']}`,
            );
            break;
          }

          this.$showAlert(
            'success',
            `${this.transactionCodeInputValue} Has Been Deleted`,
            `Successfully deleted ${this.selectedTransactionGroup[0][`${this.teamType} Transaction Code`]}`,
          );
          this.selectedTransactionGroup = [];
          this.getListMasterTransGroup();
          break;
        }
        case `View Transaction Group`: {
          if (this.selectedTransactionGroup.length == 0) {
            this.$showAlert('error', `No transaction group is selected`, `Please select a transaction group to view`);
            break;
          }

          this.$fullscreenLoading(`Getting transaction group Details`);
          this.populatePopupEntryFields(this.selectedTransactionGroup[0]['Transaction Code']);
          this.$fullscreenLoading('');

          this.popupEntryTitle = `View ${this.teamType}`;
          this.viewMode = true;
          this.viewModePK = true;
          this.showPopupEntry = true;
          break;
        }
      }
    },
    clearPopupEntryMessages: function () {
      this.popupEntryRequiredError = [];
      this.popupEntrySuccessMessages = [];
      this.popupEntryMessages = [];
      this.popupEntryErrorMessages = [];
    },
    resetPopupEntryFields: function () {
      this.popupEntryTitle = '';
      this.createdBy = '';
      this.updatedBy = '';
      this.showChargeCode = false;
      this.transactionCodeErr = '';
      this.transCodeDescErr = '';
      this.transactionCodeInputValue = '';
      this.transCodeDescription = '';
      this.transGroupTableData = [];
      this.selectedTransGroup = [];
      this.selectedChargeCode = [];
    },
    addTransGroupClicked: function (_pointerEvent) {
      this.selectedChargeCode = [];
      this.showChargeCode = true;
    },
    cancelChargeCodeClicked: function (_pointerEvent) {
      this.showChargeCode = false;
    },

    addChargeCodeClicked: function (_pointerEvent) {
      const modifiedtransGroupTableData = this.transGroupTableData;
      if(this.selectedChargeCode.length === 0) return;
      this.selectedChargeCode.forEach((code) => {
        const chargeCode = { ...code, _action: 'N', _rowid: `row${modifiedtransGroupTableData.length}` };
        modifiedtransGroupTableData.push(chargeCode);
      });

      this.transGroupTableData = [];
      this.selectedChargeCode = [];
      this.$nextTick(() => {
        this.transGroupTableData = modifiedtransGroupTableData;
          this.showChargeCode = false;
      });
    },

    deleteTransGroupClicked: async function (_pointerEvent) {
      if (this.selectedTransGroup.length === 0) {
        this.$showAlert('error', `No Charge Code selected`, 'Please select at least one Charge Code to delete', [
          { text: 'OK' },
        ]);
        return;
      }
      const deleteConfirmation = await this.$showAlert(
        'warning',
        `Delete Charge Code(s)`,
        'Are you sure you wish to delete the selected charge code(s)?',
        [{ text: 'Delete', color: 'Red', textColor: 'white' }, { text: 'Cancel' }],
      );
      if (deleteConfirmation === 'Cancel') {
        return;
      }
      const dataToDelete = this.selectedTransGroup.map((data) => data['Charges Code']);
      let modifiedtransGroupTableData = this.transGroupTableData.filter(
        (data) => !(data._action == 'N' && dataToDelete.includes(data['Charges Code'])),
      );
      modifiedtransGroupTableData = modifiedtransGroupTableData.map((data) => {
        if (dataToDelete.includes(data['Charges Code'])) {
          return { ...data, _action: 'D' };
        }
        return { ...data };
      });

      this.transGroupTableData = []; // empties table data
      this.selectedTransGroup = []; // empties selected table rows
      this.$nextTick(() => {
        this.transGroupTableData = modifiedtransGroupTableData;
        this.showChargeCode = false;
      });
    },

    popupEntrySaveClicked: async function () {
      if (this.showChargeCode) {
        const discardChanges = await this.promptDiscardChargeCodeChanges();
        if (discardChanges === 'Cancel') {
          return;
        }
        this.showChargeCode = false;
      }

      const isInvalid = this.checkPopupEntryFields();
      if (isInvalid) {
        return;
      }

      const action = this.popupEntryTitle[0];
      const requestBody = this.formatSaveRequestBody(action);
      this.$fullscreenLoading(`Saving Transaction Group`);
      const result = await this.$apiCallV2('/TransGroup/SaveTransGroup', requestBody);
      this.$fullscreenLoading('');

      if (result[0]['Results'] != '0') {
        if (action == 'N') {
          this.popupEntryErrorMessages.push(`There was an error creating transaction group: ${result[0]['ErrMsg']}`);
        } else {
          this.popupEntryErrorMessages.push(`There was an error editing transaction group: ${result[0]['ErrMsg']}`);
        }
        return;
      }

      this.viewMode = true;
      this.viewModePK = true;
      this.showChargeCode = false;
      this.popupEntryTitle = `View Transaction Group`;
      this.getListMasterTransGroup();
      if (action == 'N') {
        this.popupEntrySuccessMessages.push(`Successfully created transaction group: ${result[0]['ErrMsg']}`);
      } else {
        this.popupEntrySuccessMessages.push(`Successfully edited transaction group: ${result[0]['ErrMsg']}`);
      }
    },

    formatSaveRequestBody: function (action) {
      if (action == 'D') {
        const requestBody = {
          action: 'D',
          transactioncode: this.selectedTransactionGroup[0]['Transaction Code'].trim(),
        };
        return requestBody;
      }

      const requestBody = {
        action: this.popupEntryTitle[0],
        transactioncode: this.transactionCodeInputValue.trim(),
        description: this.transCodeDescription,
        transactiongroup: [],
      };
      const transGroup = [];
      for (const cCodeData of this.transGroupTableData) {
        if (!cCodeData._action) {
          continue;
        }
        transGroup.push({
          transactiongroup: cCodeData[`Charges Code`],
          action: cCodeData['_action'],
        });
      }
      requestBody.transactiongroup = transGroup;
      return requestBody;
    },

    promptDiscardChargeCodeChanges: function () {
      return this.$showAlert(
        'warning',
        'Discard Changes',
        `You have unsaved changes.<br>Do you wish to discard the changes?`,
        [{ text: 'Discard', color: 'Red', textColor: 'white' }, { text: 'Cancel' }],
      );
    },

    checkPopupEntryFields: function () {
      let error = false;
      this.clearPopupEntryMessages();
      if (this.transactionCodeInputValue.trim() === '') {
        this.transactionCodeErr = `Transaction Code is required!`;
        this.popupEntryRequiredError.push({ key: 'transactionCodeErr', value: this.transactionCodeErr });
        error = true;
      } else if (this.transactionCodeInputValue.length > 25) {
        // limit set by backend is 25
        this.transactionCodeErr = `Transaction Code cannot exceed 25 characters!`;
        this.popupEntryRequiredError.push({ key: 'transactionCodeErr', value: this.transactionCodeErr });
        error = true;
      }
      if (this.transCodeDescription.trim() === '') {
        this.transCodeDescErr = `Transaction Code Description is required!`;
        this.popupEntryRequiredError.push({ key: 'transCodeDescErr', value: this.transCodeDescErr });
        error = true;
      } else if (this.transCodeDescription.length > 100) {
        // limit placed by the backend is 100 characters
        this.transCodeDescErr = `Transaction Code Description cannot exceed 100 characters!`;
        this.popupEntryRequiredError.push({ key: 'transCodeDescErr', value: this.transCodeDescErr });
        error = true;
      }
      if (this.transGroupTableData.length == 0) {
        this.popupEntryRequiredError.push({ key: 'noneTransGroupErr', value: `Please add at least one Charge Code.` });
        error = true;
      }
      return error;
    },

    populatePopupEntryFields: function (rowid) {
      this.getDetails(rowid).then((details) => {
        this.transactionCodeInputValue = details.TransGroup[0]['Transaction_Code'];
        this.transCodeDescription = details.TransGroup[0]['ChargesCode'][0]['Description'];
        const transCodeList = details.TransGroup[0]['ChargesCode'].map((code) => code.Transaction_Group); // produce array of string
        this.transGroupTableData = this.chargeCodeList.filter((code) => transCodeList.includes(code['Charges Code'])); // filter out charge code list
      });
    },

    getDetails: async function (code) {
      return await this.$apiCallV2(`/Master/GetDetailsMaster`, { masterfile: 'TRANSGROUP', recordid: code });
    },

    getListMasterTransGroup: async function () {
      this.transactionGroupList = [];
      this.transactionGroupListLoading = true;
      //this.$fullscreenLoading(`Getting Transaction Group Data`);
      this.transactionGroupList = await this.$apiCallV2(`/Master/GetListMaster`, {
        masterfile: 'TRANSGROUP',
        module: 'MASTER',
      });
      //this.$fullscreenLoading('');
      this.transactionGroupListLoading = false;
    },

    getListMasterChargeCode: async function () {
      this.chargeCodeList = [];
      //this.$fullscreenLoading(`Fetching Charge Code Data`);
      this.chargeCodeList = await this.$apiCallV2('/Master/GetListMaster', {
        masterfile: 'CHARGESCODE',
        module: 'BILLRATEOT',
      });
      //this.$fullscreenLoading('');
    },

    requiredClicked: function (item) {
      if (item === 'noneTransGroupErr') {
        this.$nextTick(() => {
          this.addTransGroupClicked();
        });
      } else {
        this.$nextTick(() => {
          this.$refs[item].setFocus(); // any other error will setFocus on input element
        });
      }
    },
  },
  mounted() {
    this.$bus.$on('pageSASControlAccess', (x) => {
      if (x.page == 'Transaction Group') {
        x.data.forEach((k) => {
          const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
          if (selectedMenu) {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
          }
        });
      }
    });

    const mountedPromises = [];
    let promisesFulfilled = 0;

    mountedPromises.push(
      this.getListMasterTransGroup().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.getListMasterChargeCode().then(() => {
        this.$topLoading(++promisesFulfilled / mountedPromises.length);
      }),
    );

    Promise.allSettled(mountedPromises).then((_promiseOutcomes) => {
      this.menu = this.menu.map((menu) => ({
        ...menu,
        enabled: true,
      }));
    });
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.main {
  display: flex;
  font-size: 12px;
  padding: 10px 45px;

  > .left-menu {
    display: flex;
    justify-content: center;
  }

  > .right-container {
    width: 100%;
    margin-left: 5px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    display: flex;
    overflow: hidden;
  }

  .details-section {
    display: flex;
    flex-direction: row;
    overflow-y: scroll;
    width: 100%;
    overflow-x: hidden;
    margin-top: 5px;
    height: 100%;

    .button-bar {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin: 5px;

      > button:nth-child(1) {
        margin-right: 5px;
      }
    }

    .table-box-container {
      height: calc(100% - 40px);
      width: 100%;
      padding: 5px;
      background-color: white;
      border-radius: 5px;
      display: flex;
      overflow: hidden;
    }

    .transaction-group-list {
      width: 100%;
      min-width: 45%;
    }

    .charge-code-list {
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      min-width: 48%;
      margin-left: 3px;
    }
  }
}
</style>
